import vTooltip from './directive'
import VTooltipComp from './TooltipComp.vue'

export default vTooltip

export { VTooltipComp }
